import { render, staticRenderFns } from "./fcNewsletter.vue?vue&type=template&id=7897eb3e&"
import script from "./fcNewsletter.vue?vue&type=script&lang=js&"
export * from "./fcNewsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports